export const CONNECTOR_AUTH_LEGACY_APP_LOCATION = 'UPSELL_APP_LOCATION_UNSPECIFIED';
export const CONNECTOR_AUTH_UPSELL_TYPE = 'WAIT_FOR_CONNECTOR_AUTH_CONFIRMATION';
export const UPSELL_SLOT_IDS = {
    banner: 'ask.shell.banner',
    computerDashboardBanner: 'ask.computer.dashboard.banner',
    homepagePageBottom: 'ask.home.page_bottom',
    homepageSideCard: 'ask.home.side_card',
    homepageTopBanner: 'ask.home.top_banner',
    input: 'ask.input',
    modal: 'ask.modal',
    sidebar: 'ask.sidebar.primary',
    threadTop: 'ask.thread.in_thread_top',
};
export const UPSELL_SLOT_ACCEPTED_LOCATIONS = {
    banner: ['BANNER'],
    computerDashboardBanner: ['COMPUTER_TASKS_DASHBOARD_BANNER'],
    cometNtpBanner: ['COMET_NTP_BANNER'],
    homepageInputPill: ['ABOVE_INPUT_FLOATING_BANNER'],
    homepagePageBottomCard: ['HOMEPAGE_BOTTOM_CARD'],
    homepagePageBottomFooter: ['HOMEPAGE_BOTTOM_FOOTER'],
    homepageSideCard: ['SIDE_CARD'],
    homepageTopBanner: ['HOMEPAGE_TOP_BANNER'],
    inputThread: ['IN_THREAD_INPUT'],
    modal: ['MODAL'],
    sidebar: ['SIDEBAR'],
    threadTop: ['IN_THREAD'],
};
export const UPSELL_SLOT_LEGACY_ACCEPTED_LOCATIONS = {
    threadTopConnectorAuth: ['UPSELL_APP_LOCATION_UNSPECIFIED'],
};
//# sourceMappingURL=UpsellSlotInventory.js.map